import axios from 'axios';
import configData from 'config';

// Create an Axios instance
const api = axios.create({
    baseURL: configData.apiServer, // Replace with your API's base URL
});

// Add a request interceptor
api.interceptors.request.use(
    config => {
        // Conditionally add a token only if it exists
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `${token}`;
        }
        // Log the request for debugging
        // console.log('Request:', config);
        return config;
    },
    error => {
        // Do something with request error
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Add a response interceptor
api.interceptors.response.use(
    response => {
        // Any status code that lies within the range of 2xx causes this function to trigger
        // Do something with response data
        // console.log('Response:', response);
        return response;
    },
    error => {
        // Any status codes that fall outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response) {
            // Server responded with a status other than 2xx
            console.error('Response error:', error.response.data);
            if (error.response.status === 401) {
                console.warn('Unauthorized - clearing localStorage and redirecting');
                localStorage.clear(); // or removeItem('token') if you prefer
                window.location.href = '/'; // Redirect to login or home
            }
        } else if (error.request) {
            // Request was made but no response was received
            console.error('No response received:', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error:', error.message);
        }

        // Optionally, you can handle specific status codes
        if (error.response && error.response.status === 401) {
            // Handle unauthorized error (e.g., redirect to login)
        }

        return Promise.reject(error);
    }
);

export default api;
